<span
  id="version-number"
  [ngClass]="{ 'expand-version': expandVersion }"
  [matTooltip]="'Double click to copy - version'"
  matTooltipShowDelay="500"
  (dblclick)="copyToClipboard(version)"
>{{ version }}</span
>
